import { updateKeyInStore } from 'App';
import { store } from 'app/redux/store';
import { countries } from 'countries';
import * as Yup from 'yup';
import {
  requiredFileIf,
  requiredFiles,
} from '../../../useValidateQuestionnaire';

import {
  NonUsCorpOfPartnershipStateValues,
  updateFieldArrayKey,
  UpdateFieldArrayKeysKeys,
  updateKey,
} from './slice';

export const fields: IBaseField<
  keyof NonUsCorpOfPartnershipStateValues | UpdateFieldArrayKeysKeys
>[] = [
  {
    dependenciesTitle: 'Corporation Info',
    name: 'nameOfCorporation',
    label: 'Name of corporation',
    subLabel: () => (
      <p>
        Enter your Foreign corporation name or partnership name\nThe following
        are the ways to determine if a business is a corporation\nBusiness name
        ends with corporation or incorporated\nIf the business has a board of
        directors or was formed by the filing of articles of incorporation
      </p>
    ),
    type: 'text',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'Name of corporation',
  },
  {
    name: 'whatDoesTheBusienssDo',
    label: 'What does the busienss do?',
    subLabel: () => (
      <p>
        You need to specify the business activities such as any events that are
        undertaken by a corporation for the purpose of earning a profit. This
        information is necessary to input your business activity code on the tax
        form.For example: Investment, Business consulting, Education services,
        Real estate & rental activities, Health Care, etc.
      </p>
    ),
    type: 'text',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'What does the busienss do',
  },
  {
    name: 'streetAddress',
    label: 'Street Address',
    type: 'text',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'What does the busienss do',
  },
  {
    name: 'city',
    label: 'City',
    type: 'text',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'City',
  },
  {
    name: 'stateOrProvince',
    label: 'State or Province',
    type: 'text',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'State or Province',
  },
  {
    name: 'postCode',
    label: 'Post Code',
    type: 'text',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'Post Code',
  },
  {
    name: 'country',
    label: 'Country',
    type: 'country',
    placeholder: 'Select Country',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'corporateAccountingPeriod',
    label: 'Corporate Accounting Period',
    type: 'dateRange',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'dateOfIncorporation',
    label: 'Date of Incorporation',
    subLabel: () => (
      <p>
        The date when the certificate of incorporation is granted to the company
        by the appropriate state or national authority
      </p>
    ),
    type: 'date',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'Select Date',
  },
  {
    name: 'endOfTaxYear',
    label: 'End of Tax Year',
    type: 'date',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'Select Date',
  },

  {
    name: 'countryOfIncorporation',
    label: 'Country of Incorporation',
    type: 'country',
    placeholder: 'Select Country',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'corporationForeignTaxIdNumberifAny',
    label: 'Corporation Foreign Tax ID Number (if any)',
    type: 'text',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'Corporation',
  },
  {
    name: 'haveYouFiledForm8858Or8832InThePast',
    label:
      'Have you filed form 8858 Foreign Disregard entity or 8832 C corporation Election?',
    subLabel: () => (
      <p>
        Please check your previous tax returns completely and answer YES if
        above forms are filed
      </p>
    ),
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'areYouPersonallyResponsibleForTheCorporateFilingInTheCountryOfIncorporation',
    label:
      'Are you personally responsible for the corporate filing in the country of incorporation?',
    subLabel: () => (
      <p>
        If the US owner of a Foreign LLC does not elect disregarded entity
        status, then the foreign LLC may be trated as a corporation for tax
        purposes. Then you are personally liable to file Form 5471 along with
        your individual tax return.
      </p>
    ),
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),

    dependencies: [
      {
        name: 'foreignAgentOfCorporationNameAddressAndCountryOfLocation',
        label:
          'Foreign Agent of Corporation: Name, address and country of location',
        type: 'text',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Foreign Agent of Corporation',

        predicate: (value) => value === 'no',
      },
      {
        name: 'custodianOfCorporateAccountingRecordsNameAdressAndCountry',
        label:
          'Custodian of corporate accounting records: Name, adress and country',
        type: 'text',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Custodian of corporate',
        predicate: (value) => value === 'no',
      },
    ],
  },
  {
    dependenciesTitle: 'Ownership',
    name: 'dateYouAcquiredAtLeastA10OwnershipInTheCorporation',
    label: 'Date you acquired at least a 10% ownership in the Corporation',
    subLabel: () => (
      <p>
        There are different category to file a foreign corporation information
        return to the US. If you have owned 10% of the interest in the foreign
        companies, then you will fall into any of the category filers and have a
        requirement to file an information return to the IRS. In some cases, if
        you have more than 10% interest in the foreign corporation and
        transferred more than USD 100, 000 to the foreign company, then there is
        additional reporting of filing information required. So this is
        important to report the date you acquired 10% ownership in the foreign
        corporation.
      </p>
    ),
    type: 'date',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'Select Date',
  },
  {
    name: 'didYouAcquireOrDisposeOfSharesDuringYearYear',
    label: 'Did you acquire or dispose of shares during {year}',
    subLabel: () => (
      <p>
        This information is essential to determine your filing requirement. When
        you acquire an ownership interest in a foreign corporation above the
        prescribed limits then you may fall under one of the categories of the
        filer.\nWhen you dispose of stock in the foreign corporation that
        reduces the interest in the foreign corporation to less than the
        prescribed limits then you will satisfy the category filing requirement.
      </p>
    ),
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),

    dependencies: [
      {
        name: 'pleaseProvideDetails',
        label: 'Please provide details',
        type: 'text',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'details',
      },
    ],
  },
  {
    name: 'areYouADirectorOfTheCorporationYear',
    label: 'Are you a director of the Corporation?',
    subLabel: () => (
      <p>
        You are required to answer YES for this question, if you are a director
        of the foreign corporation. Director is the one who takes part in
        managing important business affairs. Also a person who owns more than
        51% of the outstanding shares is eligible to be a director of the
        corporation.
      </p>
    ),
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'areYouAnOfficerOfTheCorporationYear',
    label: 'Are you an officer of the Corporation?',
    subLabel: () => (
      <p>
        If you are directly involved in the daily management affairs of the
        business, then answer YES for this question. An officer can be a CEO,
        CFO, President, Vice President etc.{' '}
      </p>
    ),
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'doesYourSpouseOwnSharesInTheSameCorporation',
    label: 'Does your spouse own shares in the same corporation?',
    subLabel: () => (
      <p>This is required even if your spouse is a non-Us person</p>
    ),
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        name: 'spouseName',
        label: 'Spouse Name',
        type: 'text',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Spouse Name',
      },
      {
        name: 'spouseTaxIdifAvailable',
        label: 'Spouse Tax ID (if available)',
        type: 'text',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Spouse Tax ID',
        predicate: (value) => value === 'yes',
      },
      {
        name: 'numberOfSharesYourSpouseOwnsInCorporationifAny',
        label: 'Number of shares your spouse owns in corporation (if any)',
        type: 'text',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Number of shares',
        predicate: (value) => value === 'yes',
      },
    ],
  },
  {
    name: 'totalNumberOfIssuedSharesInTheCorporation',
    label: 'Total number of issued shares in the corporation',
    type: 'text',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'Total number',
  },

  {
    name: 'pleaseProvideDetailsAboutAllUsOwnersincludingYourselfOfTheCorporationInTheTableBelow',
    label:
      'Please provide details about All US Owners (including yourself) of the corporation in the table below',
    type: 'fieldArray',
    tooltip: '',
    comment: true,
    effect: (payload) => store.dispatch(updateFieldArrayKey(payload)),
    dependencies: [
      {
        name: 'name',
        label: 'Name',
        type: 'text',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        predicate: (value) => value,
        placeholder: 'Name',
      },
      {
        name: 'ssn',
        label: 'SSN',
        type: 'maskedInput',
        mask: '999-99-9999',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'address',
        label: 'Address',
        type: 'text',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Address',
      },
      {
        name: 'SharesOwnedAtBeginningOfAccountingPeriod',
        label: '# Shares owned at beginning of accounting period',
        type: 'text',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Shares',
      },
      {
        name: 'VotingPower',
        label: '% Voting Power',
        type: 'text',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Voting Power',
      },
    ],
    defaultDependency: {
      name: null,
      ssn: null,
      address: null,
      SharesOwnedAtBeginningOfAccountingPeriod: null,
      VotingPower: null,
    },
  },

  {
    name: 'pleaseProvideDetailsAboutAllNonUsOwnersInTheTableBelow',
    label: 'Please provide details about all NON-US owners in the table below',
    type: 'fieldArray',
    tooltip: '',
    comment: true,
    effect: (payload) => store.dispatch(updateFieldArrayKey(payload)),
    dependencies: [
      {
        name: 'name',
        label: 'Name',
        type: 'text',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Name',
      },
      {
        name: 'address',
        label: 'Address',
        type: 'text',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Address',
      },
      {
        name: 'SharesOwnedAtBeginningOfAcountingPeriod',
        label: '# Shares owned at beginning of acounting period',
        type: 'text',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Shares',
      },
      {
        name: 'SharesOwnedAtEndOfAccountingPeriod',
        label: '# Shares owned at end of accounting period',
        type: 'text',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Shares',
      },
      {
        name: 'ifEntitynotAPersonCountryOfIncorporation',
        label: 'If entity (not a person), country of incorporation',
        type: 'text',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'country of incorporation',
      },
      {
        name: 'relationToYouifAny',
        label: 'Relation to you (if any)',
        type: 'text',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Relation to you',
      },
    ],
    defaultDependency: {
      name: null,
      address: null,
      SharesOwnedAtBeginningOfAcountingPeriod: null,
      SharesOwnedAtEndOfAccountingPeriod: null,
      ifEntitynotAPersonCountryOfIncorporation: null,
      relationToYouifAny: null,
    },
  },

  {
    name: 'doTheNonUsShareholdersOwnAUsPartnershipUsTrustAreABeneficiaryOfAUsTrustOrOwn50OrMoreOfASeparateUsCorporation',
    label:
      'Do the non-US shareholders own a US partnership, US trust, are a beneficiary of a US trust, or own 50% or more of a separate US corporation?',
    subLabel: () => <p>As of 2021 - this is very important to ascertain</p>,
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),

    dependencies: [
      {
        name: 'pleaseProvideDetailsAboutAllNonUsOwnersOwnershipOfSeparateEntititesInTheTableBelow',
        label:
          'Please provide details about all non-US owners ownership of separate entitites in the table below',
        type: 'fieldArray',
        predicate: (value) => value === 'no',
        tooltip: '',
        comment: true,
        effect: (payload) => store.dispatch(updateFieldArrayKey(payload)),
        defaultDependency: {
          nonUsOwnerName: null,
          entityName: null,
          entityAddress: null,
          ownershipOrInterestInTrustAsABeneficiary: null,
        },
        dependencies: [
          {
            name: 'nonUsOwnerName',
            label: 'Non-US Owner Name',
            type: 'text',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Non-US Owner Name',
          },
          {
            name: 'entityName',
            label: 'Entity Name',
            type: 'text',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Entity Name',
          },
          {
            name: 'entityAddress',
            label: 'Entity Address',
            type: 'text',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Entity Address',
          },
          {
            name: 'ownershipOrInterestInTrustAsABeneficiary',
            label: 'Ownership % or interest in trust as a beneficiary',
            type: 'text',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Ownership',
          },
        ],
      },
    ],
  },

  {
    name: 'doAllUsOwnersCollectivelyOwnMoreThan50',
    label: 'Do all US owners collectively own more than 50%?',
    subLabel: () => (
      <p>
        This information is necessary to dtermine if your corporation is CFC
        (Controlled Foreign corporation) or not. Since if total US shareholders
        have more than 50%, then IRS treats that corporation as CFC.{' '}
      </p>
    ),
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    dependenciesTitle: 'Financials',
    name: 'YeardidTheCorporationPayYouASalaryIn',
    label: 'YearDid the corporation pay you a Salary in {year}?',
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        name: 'salaryPaidToYouByTheCorporationForYear',
        label: 'Salary Paid to you by the corporation for year',
        type: 'currency',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
    ],
  },

  {
    name: 'didTheCorporationExtendYouAnyLoansInYear',
    label: 'Did the corporation extend you any loans in {year}?',
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),

    dependencies: [
      {
        name: 'didTheCorporationExtendYouAnyLoansInYearWhatWasTheAmount',
        label: 'What was the amount?',
        type: 'number',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'the amount',
      },
    ],
  },

  {
    name: 'didYouLoadAnyFundsToTheCorporationInYear',
    label: 'Did you load any funds to the corporation in {year}?',
    subLabel: () => (
      <p>This information is required as it has tax filing impact</p>
    ),
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),

    dependencies: [
      {
        name: 'didYouLoadAnyFundsToTheCorporationInYearWhatWasTheAmount',
        label: 'What was the amount?',
        type: 'number',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'the amount',
      },
    ],
  },
  {
    name: 'didYouTransferPropertyOrCashToTheCorporationInYear',
    label: 'Did you transfer property or cash to the corporation in {year}?',
    subLabel: () => (
      <p>
        When you transfers any property or cash to a foreign corporation that
        exceeds more than a certain prescribed limit then there is additional
        form filing reporting required. Therfore this information is required.
      </p>
    ),
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),

    dependencies: [
      {
        name: 'whichAssestDidYouTransfer',
        label: 'Which assest did you transfer?',
        subLabel: () => (
          <p>
            Property transfers may trigger additional filing requirements (Form
            926)
          </p>
        ),
        type: 'select',
        options: [
          {
            label: 'None',
            value: 'None',
          },
          {
            label: 'Cash',
            value: 'Cash',
          },
          {
            label: 'Securities',
            value: 'Securities',
          },
          {
            label: 'Real Estate',
            value: 'Real Estate',
          },
        ],
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),

        dependencies: [
          {
            name: 'howMuchDidYouTransfer',
            label: 'How much did you transfer?',
            type: 'currency',
            predicate: (value) =>
              value === 'Cash' ||
              value === 'Securities' ||
              value === 'Real Estate',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
        ],
      },
    ],
  },
  {
    name: 'didYouReceiveDividendsOrOtherDistributionsFromTheCorporationDuringYear',
    label:
      'Did you receive dividends or other distributions from the Corporation during {year}?',
    subLabel: () => (
      <p>
        Dividends received from the foreign corporation is subject to tax in the
        hands of its US shareholders. It needs to be filled in the tax
        questionnaire if it may be either distributed as cash or stock.
      </p>
    ),
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),

    dependencies: [
      {
        name: 'pleaseDescribeDistributionAndAmount',
        label: 'Please describe distribution and amount',
        type: 'text',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'the amount',
      },
    ],
  },

  {
    name: 'doesTheCorporationHaveAnyInvestmentIncome',
    label: 'Does the corporation have any investment income?',
    subLabel: () => (
      <p>
        This includes all non-active income; ie rental, stocks, dividends, etc
      </p>
    ),
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'areYouASignatoryAuthorityOnTheCorporateBankAccountsOrOtherFinancialAccounts',
    label:
      'Are you a signatory authority on the corporate bank accounts or other financial accounts?',
    subLabel: () => (
      <>
        <p>
          When you have a signatory authority on any of the company's bank or
          other financial accounts, then you have additional filing reporting of
          your foreign accounts detailed in FATCA and FBAR. If YES, Please
          provide the details of your foreign account with the highest balance
          under non-US financial accounts section tab.
        </p>
        <p>
          If Yes Please input these accounts in the toe Non-US Financial
          Accounts Tab (link button)
        </p>
      </>
    ),
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    dependenciesTitle: 'Documents',
    name: 'willYouFileForm5471OnBehalfOfAnyOtherUsShareholder',
    label: 'Will you file form 5471 on behalf of any other US shareholder?',
    subLabel: () => (
      <p>
        In some cases, a US person can file this Form for other US shareholders.
        Mostly this situation comes, if one family member is having all
        shareholding. Then the person who has more shareholding will file a Form
        for other US shareholders. Includes spouse, children or anyone else
      </p>
    ),
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'wasForm5471FiledOnYourBehalfByAnotherUsOfficerdirectorOfThisForeignCorporation',
    label:
      'Was form 5471 filed on your behalf by another US officer/director of this foreign corporation?',
    subLabel: () => (
      <p>
        If somebody else filed Form 5471 on your behalf, answer YES for this
        question and attach a copy of filed Form 5471.
      </p>
    ),
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),

    dependencies: [
      {
        name: 'uploadACopyOfTheForm5471FiledOnYourBehalf',
        label: 'Upload a copy of the form 5471 filed on your behalf',
        type: 'upload',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
    ],
  },

  {
    name: 'pleaseUploadDocumentShowingCoprorateDetailsDateOfIncorporationAndShareOwnershipForAllShareholders',
    label:
      'Please upload document showing coprorate details, date of incorporation, and share ownership for all shareholders',
    type: 'upload',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'pleaseUploadCorporationBalanceSheet',
    label: 'Please upload Corporation balance sheet',
    type: 'upload',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'pleaseUploadTheCorporationsIncomeStatement',
    label: "Please upload the corporation's income statement",
    type: 'upload',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'haveYouFiledForm5471Or8865Before',
    label: 'Have you filed form 5471 or 8865 before?',
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),

    dependencies: [
      {
        name: 'pleaseUploadLastFiledForm5471Or8865',
        label: 'Please upload last filed form 5471 or 8865',
        type: 'upload',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
    ],
  },
  {
    name: 'isTheCorporationEngagedInBusinessInTheUsOrDoesItHaveAnyIncomeFromUsSources',
    label:
      'Is the corporation engaged in business in the US or does it have any income from US sources?',
    subLabel: () => <p>This helps us determine filing requirements</p>,
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
];

export const validationSchema = Yup.object().shape({});
